import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-card/50" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <div className="text-center mb-12" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main mb-4" data-id="element-139">
            Tu acceso inmediato:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-base border border-warm/20 rounded-xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-12" data-id="element-140">
          <div className="bg-warm/10 p-6 rounded-full text-warm shrink-0" data-id="element-141">
            <BookOpenIcon size={40} data-id="element-142" />
          </div>
          <div className="flex-1 text-center md:text-left" data-id="element-143">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-main mb-2" data-id="element-144">
              Mente en Calma
            </h3>
            <p className="text-muted text-base md:text-lg leading-relaxed" data-id="element-145">
              El método paso a paso de 7 días que usa la neurociencia y el
              biohacking para enviarle una señal química a tu cerebro de que el
              peligro ha pasado. Sin vueltas. Sin teoría aburrida. Solo
              protocolos que funcionan en 5 minutos o menos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-12" data-id="element-146">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-main mb-8 text-center" data-id="element-147">
            Esto es para vos si...
          </h3>
          <div className="space-y-5 max-w-2xl mx-auto" data-id="element-148">
            {['Llegás a la noche con la mente acelerada y el cuerpo agotado pero no podés dormir', 'Probaste meditación, respiraciones, apps — y nada te duró más de 3 días', 'Sentís que vivís en modo alerta aunque afuera todo esté "bien"', 'Querés una herramienta real, no otro consejo de "pensá positivo"'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-149">
                <span className="text-[#F25C05] text-xl font-bold shrink-0 mt-0.5" data-id="element-150">
                  ✓
                </span>
                <p className="text-base md:text-lg text-muted leading-relaxed" data-id="element-151">
                  {item}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-base to-card border border-warm/30 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-warm to-transparent" data-id="element-153"></div>

          <div id="price-zone" className="mb-6" data-id="element-154">
            <p className="text-sm font-bold text-urgent uppercase tracking-widest mb-4" data-id="element-155">
              Oferta por tiempo limitado
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-156">
              <span className="text-xl md:text-2xl text-muted/60 line-through decoration-2" data-id="element-157">
                ARS 45.000
              </span>
              <span className="bg-[#F25C05] text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-158">
                70% OFF
              </span>
            </div>
            <h3 className="text-5xl md:text-6xl font-serif font-bold text-warm mb-2" data-id="element-159">
              ARS 9.500
            </h3>
            <p className="text-sm md:text-base text-calm font-medium mb-6" data-id="element-160">
              Ahorrás ARS 35.500 hoy
            </p>
          </div>

          <CTAButton text="QUIERO EMPEZAR HOY — ARS 9.500" className="w-full md:w-auto md:px-12 md:py-6 text-lg" data-id="element-161" />

          <p className="mt-6 text-sm text-muted flex items-center justify-center gap-2" data-id="element-162">
            <span className="w-2 h-2 rounded-full bg-urgent animate-pulse" data-id="element-163"></span>
            Cupos limitados disponibles a este precio
          </p>
        </motion.div>
      </div>
    </section>;
}